/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { ReactNode } from "react";
// eslint-disable-next-line
import { LoadingButton as MuiLoadingButton, LoadingButtonTypeMap } from "@mui/lab";
import { DefaultComponentProps } from "@mui/material/OverridableComponent";

export type LoadingButtonProps = { children: string | ReactNode } & DefaultComponentProps<LoadingButtonTypeMap<{}, "button">>;

export default function LoadingButton({ children, ...rest }: LoadingButtonProps) {
    return (<MuiLoadingButton {...rest}>
        {/* Der <span> wird hier benötigt, dass der Button auch mit GoogleTranslate funktioniert
            https://github.com/mui/material-ui/issues/27853
        */}
        <span>{children}</span>
    </MuiLoadingButton>)
}